import { useSelector } from 'react-redux';
import { importCliTerminal } from '../utils/dynamic-imports-sl-cli';

const CliTerminal = importCliTerminal();

const About = ({ open, onCancel }) => {
  const context = useSelector(({ context }) => context);
  const slMainForceLogoutTimeoutMins = useSelector(
    ({
      main: {
        data: { logout_timeout_mins },
      },
    }) => logout_timeout_mins
  );

  const buildContextData = () => {
    let forceLogout = null;
    let help = 'N/A';
    if (
      context?.configVars?.SL_MAIN_FORCE_LOGOUT != null &&
      slMainForceLogoutTimeoutMins != null
    ) {
      if (
        context?.configVars?.SL_MAIN_FORCE_LOGOUT > slMainForceLogoutTimeoutMins
      ) {
        forceLogout = context?.configVars?.SL_MAIN_FORCE_LOGOUT;
        help = 'SL_MAIN_FORCE_LOGOUT (config_var)';
      } else {
        forceLogout = slMainForceLogoutTimeoutMins;
        help = 'logout_timeout_mins (/get_app_design)';
      }
    } else if (context?.configVars?.SL_MAIN_FORCE_LOGOUT != null) {
      forceLogout = context?.configVars?.SL_MAIN_FORCE_LOGOUT;
      help = 'SL_MAIN_FORCE_LOGOUT (config_var)';
    } else if (slMainForceLogoutTimeoutMins != null) {
      forceLogout = slMainForceLogoutTimeoutMins;
      help = 'logout_timeout_mins (/get_app_design)';
    }

    return [
      {
        key: '1',
        name: 'Session timeout',
        value: `${forceLogout} minutes`,
        help: help,
      },
    ];
  };

  const buildContextColumns = () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
      },
      {
        title: 'Value',
        dataIndex: 'value',
      },
      {
        title: 'Help',
        dataIndex: 'help',
      },
    ];
  };

  return (
    <CliTerminal
      title="About | Smartlis - SL-Main "
      modal={true}
      onCancel={onCancel}
      open={open}
      showTabJSON={false}
      width={750}
      height={500}
      consoleOutput={context.consoleOutput}
      contextTabTitle={'Context'}
      contextData={buildContextData()}
      contextColumns={buildContextColumns()}
      onResize={(width, height) => {}}
    />
  );
};

export default About;
